module.exports = __webpack_public_path__ + "static/img/bg-es.a6ffd357.png";